import React, { FunctionComponent } from "react";

import { NavigationSection } from "../../navigation";
import { MenuItemActivatedType } from "../../types";
import { ActionMenu } from "../ActionMenu";
import { CloseActionItem } from "../CloseActionItem";
import { FavoriteActionItem } from "../FavoriteActionItem";
import { OpenActionItem } from "../OpenActionItem";
import { OpenInTabActionItem } from "../OpenInTabActionItem";

export type OpenedProfileRightPartComponentProps = {
    /** Viz. dokumentace v ActionMenu. */
    isActive?: boolean;
    /** Identifikátor otevřené instance formuláře. */
    formInstanceId: string;
    /** Povoluje zobrazení akcí otevírajících novou instanci formuláře s aplikovaným profilem. */
    windowActionsEnabled: boolean;
    /** Povoluje zobrazení akce pro zavření instance profilu formuláře. */
    isCloseActionEnabled: boolean;
    /** Indikátor, zda je zaměřená některá akční položka. */
    isActionItemFocused: boolean;
    /** Sekce, ve které je komponenta vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
    /** Id profilu */
    profileId: number;
    /** Id menu */
    menuItemId: number;
};

/**
 * Menu historie obsahuje 2 části: "otevřené položky" a "historické položky".
 * Část "otevřené položky" zobrazuje různé typy položek.
 * Jedním z typů těchto položek je OpenedProfile = "otevřený formulář s aplikovaným profilem, pro který existuje položka profilu v navigačním menu".
 * Komponenta slouží jako pravá část (kontextové menu) pro OpenedProfile.
 */
export const OpenedProfileRightPartComponent: FunctionComponent<OpenedProfileRightPartComponentProps> = ({
    isActive,
    formInstanceId,
    windowActionsEnabled,
    isCloseActionEnabled,
    isActionItemFocused,
    section,
    profileId,
    menuItemId,
}) => {
    if (!windowActionsEnabled && !isCloseActionEnabled) {
        return null;
    }

    const actions = [];
    if (menuItemId && profileId) {
        actions.push(
            <FavoriteActionItem key="favoriteAction" itemId={menuItemId} activatableItemType={MenuItemActivatedType.formFavoriteActionItem} section={section} profileId={profileId}/>,
        );
    }

    if (windowActionsEnabled) {
        actions.push(
            <OpenActionItem key="openAction" itemId={formInstanceId} activatableItemType={MenuItemActivatedType.openFormInstanceActionItem} section={section}/>,
            <OpenInTabActionItem key="openInTabAction" itemId={formInstanceId} activatableItemType={MenuItemActivatedType.openFormInstanceInTabActionItem} section={section} />,
        );
    }
    if (isCloseActionEnabled) {
        actions.push(<CloseActionItem key="closeAction" {...{ formInstanceId, section }} />);
    }
    return (
        <ActionMenu {...{ isActive, isActionItemFocused }}>
            {actions}
        </ActionMenu>
    );
};
